import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';

import { JobOffersLayout } from './-components/JobOffersLayout';

const jobOffersSearchSchema = z.object({
  page: z.number().catch(1).default(1),
  profession: z.enum(['doctor', 'nurse', 'student', 'other']).optional().catch(undefined),
  specializations: z.array(z.string()).optional().catch(undefined),
  countries: z.array(z.string()).optional().catch(undefined),
  regions: z.array(z.string()).optional().catch(undefined),
  cities: z.array(z.string()).optional().catch(undefined),
  founderTypes: z.array(z.string()).optional().catch(undefined),
  employmentTypes: z.array(z.string()).optional().catch(undefined),
  facilityTypes: z.array(z.string()).optional().catch(undefined),
  experienceTypes: z.array(z.string()).optional().catch(undefined),
  salaryMin: z.number().optional().catch(undefined),
  salaryMax: z.number().optional().catch(undefined),
  includeUnpaid: z.boolean().optional().catch(undefined),
  includeUndisclosed: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/{-$locale}/job-offers')({
  validateSearch: jobOffersSearchSchema,
  component: JobOffersLayout,
  errorComponent: ErrorComponent,
});
